import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { regenerateOrganizationCredentials } from 'services/organization.service';

//core components
import ReadOnlyField from 'components/ReadOnlyField/ReadOnlyField';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';

class OrganizationAuthenticationSection extends Component {
	state = {
		appSecret: undefined,
	};

	regenerateCredentials = async () => {
		const {
			id,
			onCredentialsGenerated,
		} = this.props;
		const { appKey = undefined, appSecret = undefined } = await regenerateOrganizationCredentials(id);
		this.setState({
			appSecret,
		});
		onCredentialsGenerated && onCredentialsGenerated(appKey);
	}

	render() {
		const {
			appKey,
		} = this.props;

		const {
			appSecret,
		} = this.state;

		return (
			<>
				<GridItem xs={12} sm={12} md={6}>
					<span>
						Use the Application key and Application Secret for authentication of the organization Portal at the License service
					</span>
				</GridItem>
				<GridItem xs={12} sm={12} md={6}>
					<ReadOnlyField
						label='App Key'
						value={ appKey || '' }
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={6}>
					<ReadOnlyField
						label='App Secret'
						value={ appSecret || 'App secret is displayed only once due to security reasons. You may generate a new pair of app key and secret anytime.' }
					/>

				</GridItem>
				<GridItem md={12}>
					<Tooltip
						title={'Generate a new pair of App key and secret'}
						placement='right'
					>
						<Button
							size="sm"
							color="warning"
							onClick={this.regenerateCredentials}
						>
							Re-generate APP credentials
						</Button>
					</Tooltip>
				</GridItem>
			</>
		)}
}


export default OrganizationAuthenticationSection;
